/* IT Gallery — Legion Pro 5 + FREE H600 headset promo (auto-expires via Liquid gate)
   1) Auto-adds the free headset when the qualifying laptop is in the cart, removes it
      when the laptop is gone. The LKR 0 price comes from the automatic Buy-X-Get-Y discount.
   2) Fast path: when a qualifying laptop add request is detected, the gift is added
      immediately (no cart pre-fetch), then the drawer (side-cart section) is
      re-rendered in place.
   3) Shows a live "you're saving" badge in the cart drawer, read from the real cart
      discount amount (so it stays correct if prices change).
   4) Repositions the promo banners into their correct page slots. */
(function () {
  var P = window.ITG_PROMO || {};
  if (P.active === false) return;

  var GIFT_PROP = '_itg_free_gift';
  /* Each pair: buy = qualifying laptop variant id, gift = free product variant id,
     val = gift tag, giftInCart = cached knowledge (null = unknown). */
  var PAIRS = (P.pairs || []).map(function (p) {
    return { buy: String(p.buy || ''), gift: String(p.gift || ''), val: String(p.val || ''), giftInCart: null };
  }).filter(function (p) { return p.buy && p.gift && p.val; });
  var busy = false;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function addGift(p) {
    var props = {}; props[GIFT_PROP] = p.val;
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(p.gift), quantity: 1, properties: props }] })
    });
  }
  function removeGift(key) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  /* ---------- live savings badge (cart drawer + cart page) ---------- */
  function money(cents) {
    var fmt = (window.Shopify && window.Shopify.money_format) || 'LKR {{amount}}';
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts[1] === '00' ? parts[0] : parts.join('.');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount).replace(/<[^>]+>/g, '');
  }
  function giftSavings(cart) {
    var items = cart.items || [];
    var total = 0;
    PAIRS.forEach(function (p) {
      items.forEach(function (it) {
        if (String(it.variant_id) === p.gift && it.properties && it.properties[GIFT_PROP] === p.val) {
          var d = it.total_discount || 0;
          if (!d && it.line_level_discount_allocations) {
            it.line_level_discount_allocations.forEach(function (a) { d += a.amount || 0; });
          }
          total += d;
        }
      });
    });
    return total;
  }
  function decorate(cart) {
    var save = giftSavings(cart);
    var targets = [];
    var drawer = document.querySelector('#cart .sticky-in-panel ul.l4tt');
    if (drawer) targets.push(drawer);
    var page = document.querySelector('.template-cart ul.l4tt, #content .l4tt');
    if (page && page !== drawer) targets.push(page);
    targets.forEach(function (ul) {
      var old = ul.parentNode.querySelector('.itg-cart-save');
      if (!save) { if (old) old.parentNode.removeChild(old); return; }
      var html = '🎁 Free Legion H600 headset included, you save <b>' + money(save) + '</b>';
      if (old) { old.innerHTML = html; return; }
      var el = document.createElement('div');
      el.className = 'itg-cart-save';
      el.innerHTML = html;
      ul.parentNode.insertBefore(el, ul);
    });
  }

  /* Re-render the side-cart drawer from the live cart; badge count is read from the
     rendered section itself (header[data-totalqty]), no extra cart fetch needed. */
  function refreshDrawer() {
    var drawer = document.getElementById('cart'); // <aside id="cart" class="m6pn">
    return fetch(ROOT + '?section_id=side-cart', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var section = tpl.querySelector('.shopify-section') || tpl.firstElementChild;
        if (!section) return;
        /* Swap content INSIDE the existing .shopify-section wrapper (the theme's
           drawer layout CSS depends on it); fall back to #cart only if absent. */
        var target = drawer ? (drawer.querySelector('.shopify-section') || drawer) : null;
        if (target) target.innerHTML = section.innerHTML;
        var head = section.querySelector('header[data-totalqty]');
        if (head) {
          var qty = head.getAttribute('data-totalqty');
          document.querySelectorAll('#cart-count').forEach(function (el) {
            el.textContent = ' ' + qty;
          });
        }
      })
      .catch(function () {})
      .then(notifyTheme)
      .then(function () { return getCart().then(decorate).catch(function () {}); });
  }

  function notifyTheme() {
    ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxCart.afterCartLoad'].forEach(function (ev) {
      try { document.dispatchEvent(new CustomEvent(ev)); } catch (e) {}
    });
  }

  /* Fast path: a qualifying laptop add detected in the outgoing request —
     add that pair's gift at once. */
  function fastAddGift(p) {
    if (busy) return;
    busy = true;
    addGift(p)
      .then(function (r) {
        if (r && r.ok) { p.giftInCart = true; }
        return refreshDrawer();
      })
      .catch(function () { p.giftInCart = null; })
      .then(function () {
        busy = false;
        if (p.giftInCart !== true) reconcile(); // fallback if the fast add failed
      });
  }

  /* Full reconcile: fetch the cart, then add/remove each pair's gift as needed. */
  function reconcile() {
    if (busy || !PAIRS.length) return Promise.resolve();
    busy = true;
    return getCart().then(function (cart) {
      var items = cart.items || [];
      var ops = [];
      PAIRS.forEach(function (p) {
        var hasBuy = items.some(function (it) { return String(it.variant_id) === p.buy; });
        var gift = items.filter(function (it) {
          return String(it.variant_id) === p.gift && it.properties && it.properties[GIFT_PROP] === p.val;
        })[0] || null;
        p.giftInCart = !!gift;
        if (hasBuy && !gift) {
          ops.push(function () { return addGift(p).then(function () { p.giftInCart = true; }); });
        } else if (!hasBuy && gift) {
          ops.push(function () { return removeGift(gift.key).then(function () { p.giftInCart = false; }); });
        } else if (gift && gift.quantity > 1) {
          /* keep exactly one free unit tagged as the gift; extra units are paid */
          ops.push(function () {
            return fetch(ROOT + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: gift.key, quantity: 1 })
            });
          });
        }
      });
      if (!ops.length) { decorate(cart); return; }
      return ops.reduce(function (chain, op) { return chain.then(op); }, Promise.resolve()).then(refreshDrawer);
    }).catch(function () {}).then(function () { busy = false; });
  }

  /* Watch cart-changing requests; use the fast path when a qualifying laptop is added. */
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;

  function bodyToString(b) {
    try {
      if (!b) return '';
      if (typeof b === 'string') return b;
      if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) return b.toString();
      if (typeof FormData !== 'undefined' && b instanceof FormData) {
        var parts = [];
        b.forEach(function (v, k) { parts.push(k + '=' + v); });
        return parts.join('&');
      }
    } catch (e) {}
    return '';
  }
  function pairForAddBody(bodyStr) {
    if (!bodyStr) return null;
    for (var i = 0; i < PAIRS.length; i++) {
      if (bodyStr.indexOf(PAIRS[i].buy) !== -1) return PAIRS[i];
    }
    return null;
  }

  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var watch = CART_WRITE.test(url) && !busy;
      var addPair = (watch && CART_ADD.test(url)) ? pairForAddBody(bodyToString(init && init.body)) : null;
      return _fetch.apply(this, arguments).then(function (res) {
        if (watch && res && res.ok) {
          if (addPair && addPair.giftInCart === false) fastAddGift(addPair);
          else setTimeout(reconcile, 10);
        }
        return res;
      });
    };
  }
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__itgUrl = u; return _open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      var url = this.__itgUrl || '';
      if (CART_WRITE.test(url) && !busy) {
        var addPair = CART_ADD.test(url) ? pairForAddBody(bodyToString(body)) : null;
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) {
            if (addPair && addPair.giftInCart === false) fastAddGift(addPair);
            else setTimeout(reconcile, 10);
          }
        });
      }
      return _send.apply(this, arguments);
    };
  }

  /* Re-apply the savings badge whenever the theme re-renders the drawer itself. */
  ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxCart.afterCartLoad'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      if (busy) return;
      setTimeout(function () { getCart().then(decorate).catch(function () {}); }, 150);
    });
  });

  function reveal(el) { if (!el) return; el.removeAttribute('hidden'); el.classList.remove('itg-prepos'); }

  function firstDirectSection(parent) {
    var kids = parent.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].classList && kids[i].classList.contains('shopify-section')) return kids[i];
    }
    return null;
  }

  function positionBanners() {
    var content = document.getElementById('content');
    var home = document.querySelector('[data-itg-slot="home"]');
    if (home && content) {
      var hero = firstDirectSection(content); // the hero/slideshow is the first section
      if (hero && hero.parentNode) { hero.parentNode.insertBefore(home, hero.nextSibling); }
      else { content.insertBefore(home, content.firstChild); }
      reveal(home);
    }
    var coll = document.querySelector('[data-itg-slot="collection"]');
    if (coll && content) { content.insertBefore(coll, content.firstChild); reveal(coll); }
    var prod = document.querySelector('[data-itg-slot="product"]');
    if (prod) {
      var anchor = document.querySelector('form[action*="/cart/add"]')
        || document.querySelector('.product-form, .product__info, .pf_inner, [data-product-form]');
      if (anchor && anchor.parentNode) { anchor.parentNode.insertBefore(prod, anchor); }
      reveal(prod);
    }
  }

  function initStickyVideo() {
    var v = document.getElementById('itg-svid');
    if (!v) return;
    var KEY = 'itg_svid_closed';
    try { if (sessionStorage.getItem(KEY) === '1') return; } catch (e) {}
    v.classList.remove('itg-hide');
    var btn = v.querySelector('.itg-svid__close');
    if (btn) btn.addEventListener('click', function () {
      v.classList.add('itg-hide');
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    });
  }

  function init() { positionBanners(); reconcile(); initStickyVideo(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
